var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFollowFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.11,
    viewBox: "0 0 40 40.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.328,22.728h-5.51v5.51a1.857,1.857,0,0,1-1.873,1.873,1.793,1.793,0,0,1-1.873-1.873v-5.51h-5.51a1.857,1.857,0,0,1-1.873-1.873,1.793,1.793,0,0,1,1.873-1.873h5.51v-5.51A1.857,1.857,0,0,1,21.945,11.6a1.793,1.793,0,0,1,1.873,1.873v5.51h5.51a1.873,1.873,0,0,1,0,3.747ZM21.945.8A20.055,20.055,0,1,0,42,20.855,20.034,20.034,0,0,0,21.945.8Z",
    transform: "translate(-2 -0.8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFollowFill);
export default __webpack_public_path__ + "static/media/icon-follow-fill.19829e30.svg";
export { ForwardRef as ReactComponent };